import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Link,
  Stack,
  Divider,
  Chip,
} from "@mui/material";

// Formatea un importe con la moneda del item (fallback ARS). null -> "-".
const fmt = (n, cur) =>
  n == null || n === ""
    ? "-"
    : new Intl.NumberFormat("es-AR", {
        style: "currency",
        currency: cur || "ARS",
        maximumFractionDigits: 0,
      }).format(Number(n));

// Modal de detalle de Buy Box: compara la publicación ganadora del catálogo
// contra la nuestra. `competition` es el objeto catalog_competition(_c) que arma
// el Lambda/pull (status, current_price, price_to_win, item_permalink, winner...).
export default function BuyBoxModal({ open, onClose, competition, title }) {
  if (!competition) return null;
  const c = competition;
  const winner = c.winner || {};
  const isWinnerUs = !!c.is_winner;

  return (
    // stopPropagation: el modal vive dentro de la celda de la grilla; evita que el
    // click se propague a la fila (selección/expansión del DataGrid).
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      onClick={(e) => e.stopPropagation()}
    >
      <DialogTitle>
        Estado de Buy Box{title ? ` — ${title}` : ""}
      </DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2}>
          <Box>
            <Chip
              label={c.status_label || c.status || "—"}
              color="warning"
              size="small"
            />
            {c.price_to_win != null && (
              <Typography variant="body2" sx={{ mt: 1 }}>
                Precio para volver a ser competitivo (price&nbsp;to&nbsp;win):{" "}
                <b>{fmt(c.price_to_win, c.currency_id)}</b>
              </Typography>
            )}
          </Box>

          <Divider />

          <Box>
            <Typography variant="subtitle2">Tu publicación</Typography>
            <Typography variant="body2">
              Precio actual: <b>{fmt(c.current_price, c.currency_id)}</b>
            </Typography>
            {c.item_permalink ? (
              <Link href={c.item_permalink} target="_blank" rel="noopener noreferrer">
                Ver mi publicación ↗
              </Link>
            ) : (
              <Typography variant="caption" color="text.secondary">
                Sin enlace disponible
              </Typography>
            )}
          </Box>

          <Box>
            <Typography variant="subtitle2">
              Publicación ganadora del catálogo
            </Typography>
            <Typography variant="body2">
              Precio ganador:{" "}
              <b>{fmt(winner.price, winner.currency_id || c.currency_id)}</b>
            </Typography>
            {winner.permalink ? (
              <Link
                href={winner.permalink}
                target="_blank"
                rel="noopener noreferrer"
              >
                Ver publicación ganadora ↗
              </Link>
            ) : (
              <Typography variant="caption" color="text.secondary">
                {isWinnerUs
                  ? "Tu publicación es la ganadora"
                  : "Sin enlace disponible"}
              </Typography>
            )}
          </Box>

          {Array.isArray(c.reason) && c.reason.length > 0 && (
            <Typography variant="caption" color="text.secondary">
              Motivo: {c.reason.join(", ")}
            </Typography>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cerrar</Button>
      </DialogActions>
    </Dialog>
  );
}
